import CodeLine from "../CodeLine/CodeLine";
import "./About.scss";

export default function Description() {
  const description = [
    "/**",
    " * Full Stack Developer",
    " * CALX Consulting",
    " * Tunis, Tunisia",
    " * Jul 2022 - Jan 2023",
    " * ",
    " * Developed dynamic web applications using React.js and Node.js.",
    " * Built and documented reusable UI components with Storybook.",
    " * Implemented scalable APIs with Express.js and Fastify.",
    " * Improved performance, responsiveness, and code quality.",
    " * Used optimization techniques, unit testing, and CI/CD pipelines.",
    " */",
  ];

  return (
    <div className="description-layout">
      <div className="description-layout__desktop">
        {description.map((line, idx) => (
          <CodeLine
            key={idx}
            lineNumber={idx + 1}
            words={[{ text: line, class: "comment" }]}
          />
        ))}
      </div>

      <div className="description-layout__mobile">
        Full Stack Developer at CALX Consulting (Tunis, Tunisia). Developed dynamic web
        applications with React.js and Node.js. Built and documented reusable UI components
        with Storybook and implemented scalable APIs with Express.js and Fastify. Improved
        performance, responsiveness, and code quality using optimization techniques, unit
        testing, and CI/CD pipelines in agile teams.
      </div>
    </div>
  );
}
